import { render, staticRenderFns } from "./IconLsMessage.vue?vue&type=template&id=29a04724"
import script from "./IconLsMessage.vue?vue&type=script&lang=js"
export * from "./IconLsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports